import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FocusableItem, TestableComponent } from 'common/interfaces';
import { getClassName } from 'common/utils';
import useHoverable from 'common/utils/hooks/useHoverable';
import React, { useCallback, useEffect } from 'react';

export interface SimpleScrollViewItemProps extends FocusableItem, TestableComponent {
  stripeItemClassName?: string;
  className?: string;
  children: React.ReactElement<{ focused?: boolean }>;
}
function SimpleScrollViewItem({
  focusKey: focusKeyParam,
  stripeItemClassName: focusedClassName = 'focused',
  className,
  children,
  onArrowPress,
  onBlur,
  onClick: onClickParam,
  onEnterPress,
  onFocus,
  isFocusBoundary,
  // onHover,
  // onMouseLeave,
  initiallyFocused = false,
  testId
}: SimpleScrollViewItemProps) {
  const {
    ref,
    focused: isFocused,
    focusKey,
    focusSelf
  } = useFocusable({
    focusKey: focusKeyParam,
    onFocus,
    onBlur,
    onEnterPress,
    onArrowPress,
    isFocusBoundary
  });
  const { active: focused, onMouseEnter, onMouseLeave } = useHoverable(isFocused);

  useEffect(() => {
    if (initiallyFocused) {
      focusSelf();
    }
  }, [initiallyFocused]);

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      focusSelf();
      onClickParam && onClickParam(e);
    },
    [onClickParam]
  );

  return (
    <div
      ref={ref}
      key={focusKey}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={getClassName('simple-scroll-view-item', {
        [focusedClassName]: focused,
        [className || '']: className
      })}
      data-test-id={testId}
    >
      {React.cloneElement(children, { focused })}
    </div>
  );
}

export default React.memo(SimpleScrollViewItem);
